import styled from "@emotion/styled";

import { fontRoboto, setFullViewportWidthStyles, theme } from "shared/lib/styles";

export const Container = styled.div`
  ${setFullViewportWidthStyles()}
  z-index: 2;

  display: none;

  block-size: 32px;

  border-block-end: 2px solid #7ca9ff;

  background-color: #000000;

  transform: translate3d(0, 0, 0);

  ${theme.breakpoints.up("tablet")} {
    display: block;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  block-size: 100%;
  max-inline-size: 1344px;
  margin-inline: auto;
  padding-inline: 32px;
`;

export const DateWeatherAndBackToOldScmpButton = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
`;

export const BackToOriginalScmpButton = styled.div`
  inline-size: fit-content;
  padding-block: 8px;
  padding-inline: 12px;

  color: #001246;
  font-weight: 700;
  font-size: 12px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: normal;

  background-color: #7ca9ff;

  cursor: pointer;
`;
